import { useEffect, useState } from "react";

import PageContainer from "../../Component/Common/Page";
import MultiButton from "../../Component/extra/MultiButton";
import Coupons from "./Coupons";
import CouponCreate from "./CreateCoupon";
import { useDispatch } from "react-redux";
import { getSubscriptions } from "../../store/subscription/subscription.action";
import PageHeader from "../../Component/Common/PageHeader";

const TabsName = {
  Tab1: "All Coupons",
  Tab2: "Create Coupon",
};

const CouponsPage = () => {
  const dispatch = useDispatch();

  const [currentTab, setCurrentTab] = useState(TabsName.Tab1);

  useEffect(() => {
    dispatch(getSubscriptions({ limit: 100 }));
  }, [dispatch]);

  return (
    <PageContainer>
      <PageHeader heading={"Welcome Admin"} subHeading={"Coupons"} />

      <MultiButton
        label={Object.values(TabsName)}
        multiButtonSelect={currentTab}
        setMultiButtonSelect={setCurrentTab}
      />

      {currentTab === TabsName.Tab1 && (
        <Coupons
          changeTab={() => {
            setCurrentTab(TabsName.Tab2);
          }}
        />
      )}
      {currentTab === TabsName.Tab2 && (
        <CouponCreate changeTab={() => setCurrentTab(TabsName.Tab1)} />
      )}
    </PageContainer>
  );
};

export default CouponsPage;
